// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close_ZLUIt {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/billing/ReplaceCustomerLocator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B","sourcesContent":[".close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"close": `close_ZLUIt`
};
export default ___CSS_LOADER_EXPORT___;
